"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createAudioVideoObserver = createAudioVideoObserver;
var _StudioLogger = require("@studio/logger/StudioLogger");
var _logger = require("../../constants/logger");
var _metricsDidReceiveHandler = require("../../metrics/MetricsDidReceive/metricsDidReceiveHandler");
var _audioVideoDidStartHandler = require("./AudioVideoDidStart/audioVideoDidStartHandler");
var _audioVideoDidStopHandler = require("./AudioVideoDidStop/audioVideoDidStopHandler");
var _audioVideoDidStartConnectingHandler = require("./AudioVideoDidStartConnecting/audioVideoDidStartConnectingHandler");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var logger = new _StudioLogger.StudioLogger(_logger.loggerName);
function createAudioVideoObserver(dispatch, actions, meetingSession, meetingResponse, attendeeResponse) {
  var hasLocalTile = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
  var currentAttendeeId = attendeeResponse.Attendee.AttendeeId;
  function sendChimeConnectionLogs(event) {
    var title = "".concat(event, " - attendeeId: ").concat(currentAttendeeId);
    logger.info(title, _objectSpread(_objectSpread({}, networkPayload), {}, {
      title: title,
      'attendee-id': currentAttendeeId,
      chimeEventName: event
    }));
  }
  var videoTileDidUpdateHandler = actions.videoTileDidUpdateHandler,
    videoTileWasRemovedHandler = actions.videoTileWasRemovedHandler,
    networkPayload = actions.networkPayload,
    setAttendeeNetworkHealth = actions.setAttendeeNetworkHealth,
    setAttendeeReceivedFrame = actions.setAttendeeReceivedFrame,
    remoteVideoSourcesDidChangeHandler = actions.remoteVideoSourcesDidChangeHandler;
  var audioVideoObserver = {
    audioVideoDidStart: function audioVideoDidStart() {
      (0, _audioVideoDidStartHandler.audioVideoDidStartHandler)(meetingSession, meetingResponse, attendeeResponse, hasLocalTile);
    },
    audioVideoDidStartConnecting: function audioVideoDidStartConnecting(reconnecting) {
      (0, _audioVideoDidStartConnectingHandler.audioVideoDidStartConnectingHandler)(reconnecting, meetingResponse, attendeeResponse);
    },
    // Use case 28 https://github.com/aws/amazon-chime-sdk-js
    audioVideoDidStop: function audioVideoDidStop(sessionStatus) {
      (0, _audioVideoDidStopHandler.audioVideoDidStopHandler)(sessionStatus, meetingSession, meetingResponse, attendeeResponse, hasLocalTile);
    },
    connectionDidBecomeGood: function connectionDidBecomeGood() {
      sendChimeConnectionLogs('connectionDidBecomeGood');
    },
    connectionDidBecomePoor: function connectionDidBecomePoor() {
      sendChimeConnectionLogs('connectionDidBecomePoor');
    },
    connectionDidSuggestStopVideo: function connectionDidSuggestStopVideo() {
      sendChimeConnectionLogs('connectionDidSuggestStopVideo');
    },
    connectionHealthDidChange: function connectionHealthDidChange(connectionHealthData) {
      networkPayload.connectionHealthData = connectionHealthData;
    },
    metricsDidReceive: function metricsDidReceive(clientMetricReport) {
      (0, _metricsDidReceiveHandler.metricsDidReceiveHandler)(dispatch, setAttendeeNetworkHealth, setAttendeeReceivedFrame, meetingSession, currentAttendeeId, networkPayload, clientMetricReport);
    },
    remoteVideoSourcesDidChange: function remoteVideoSourcesDidChange(videoSources) {
      remoteVideoSourcesDidChangeHandler(videoSources, meetingSession, meetingResponse);
    },
    videoTileWasRemoved: function videoTileWasRemoved(tileId) {
      videoTileWasRemovedHandler(tileId);
    },
    videoTileDidUpdate: function videoTileDidUpdate(tileState) {
      videoTileDidUpdateHandler(tileState);
    }
  };
  return audioVideoObserver;
}